// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"apple"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 12.4997C21 16.4187 18.5039 20.0039 15.5 20.9879C14.0008 21.479 13.5024 20.4997 12 20.4997C10.4976 20.4997 9.99914 21.4812 8.5 20.9879C5.5035 20.0017 3 16.4187 3 12.4997C3 9.37809 4.24905 6.99933 6.5 5.74965C8.75095 4.49997 10.151 5.49965 12 5.49965C13.8482 5.49965 15.25 4.50342 17.5 5.74959C19.75 6.99577 21 9.37731 21 12.4997Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10 8.46484C11.2238 9.17263 12.7757 9.17263 13.9995 8.46484M11.9998 8.5V3M21 12.4997C21 9.37731 19.75 6.99577 17.5 5.74959C15.25 4.50342 13.8482 5.49965 12 5.49965C10.151 5.49965 8.75095 4.49997 6.5 5.74965C4.24905 6.99933 3 9.37809 3 12.4997C3 16.4187 5.5035 20.0017 8.5 20.9879C9.99914 21.4812 10.4976 20.4997 12 20.4997C13.5024 20.4997 14.0008 21.479 15.5 20.9879C18.5039 20.0039 21 16.4187 21 12.4997Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-apple')
export default class AppleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'apple',
    }
  }
}
